import React, {useState} from 'react';
import {withRouteData, Head} from 'react-static';
import Markdown from '../../lib/Markdown';
import {trackEvent} from '../../lib/track';
import styles from './style.scss';

export default withRouteData(function Contact({page}) {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const invalid = name.trim().length < 3 || email.trim().length < 3 || message.trim().length < 10 || !validEmail(email);

  const handleSubmit = async event => {
    event.preventDefault();

    if (loading) return;
    setLoading(true);

    try {
      const json = await sendContactForm({name, email, message});
      if (json.status === 'ERROR') throw new Error('Error status from server');
      if (json.status === 'REJECTED') throw new Error('Server rejected submission');
      trackEvent('generate_lead');
    } catch (error) {
      trackEvent('error', {value: error});
    } finally {
      setSent(true);
    }
  };

  return (
    <React.Fragment>
      <Head>
        <title>{page.title}</title>
      </Head>
      <Markdown source={page.content} className={styles.content} />
      {sent ? (
        <div className={styles.thanks}>
          <p>Thanks I’ll be in touch shortly!</p>
        </div>
      ) : (
        <form name="contact" className={styles.form} onSubmit={handleSubmit} disabled={loading}>
          <fieldset>
            <label htmlFor="contact-name">Name</label>
            <input
              id="contact-name"
              type="text"
              name="name"
              value={name}
              disabled={loading}
              required
              onChange={e => setName(e.target.value)}
            />
          </fieldset>
          <fieldset>
            <label htmlFor="contact-email">Email</label>
            <input
              id="contact-email"
              type="email"
              name="email"
              value={email}
              disabled={loading}
              required
              onChange={e => setEmail(e.target.value)}
            />
          </fieldset>
          <fieldset>
            <label htmlFor="contact-message">Message</label>
            <textarea
              id="contact-message"
              name="message"
              value={message}
              disabled={loading}
              required
              onChange={e => setMessage(e.target.value)}
            />
          </fieldset>
          <fieldset>
            <button type="submit" onClick={handleSubmit} disabled={loading || invalid}>
              {loading ? 'Sending...' : 'Send'}
            </button>
          </fieldset>
        </form>
      )}
    </React.Fragment>
  );
});

const URL = process.env.NODE_ENV === 'development' ? 'http://localhost:9000/contact' : '/.netlify/functions/contact';

async function sendContactForm(data) {
  const response = await fetch(URL, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });

  return response.json();
}

function validEmail(email) {
  return /.+@.+\..+/.test(email.trim());
}
